import { memo } from 'react'

const script = {
  __html: `
  (function(a,l,v,i,s){
    a._Alviss=[];
    a.Alvis=function() {a._Alviss.push(Array.prototype.slice.call(arguments));}
    a.alvis_config={alvis_id:"owilwi3h"};
    i=l.getElementsByTagName('head')[0];
    s=l.createElement('script');s.async=1;
    s.src=v;
    i.appendChild(s);
  })(window,document,'//assets.getalvis.com/alvis-onboard-1.0.14.js');`,
}

function IntercomeChecklistScript(): JSX.Element {
  // eslint-disable-next-line react/no-danger
  return <script defer type="text/javascript" dangerouslySetInnerHTML={script} />
}

export default memo(IntercomeChecklistScript)
